var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"s-select-dropdown__item",class:{
    'selected': _vm.itemSelected,
    'is-wrap': _vm.wrap,
    'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
    'hover': _vm.hover
  },attrs:{"data-qa":_vm.dataQa},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.selectOptionClick.apply(null, arguments)},"mouseenter":_vm.hoverItem}},[_vm._t("default",function(){return [(_vm.labelByQuery)?_c('span',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.labelByQuery),expression:"labelByQuery"}]}):_c('span',[_vm._v(" "+_vm._s(_vm.currentLabel)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }